import React, { Component } from "react";
import {
    Panel,
    Modal,
    Button
}                           from "react-bootstrap";
  import {
    ToastContainer,
    toast
}                           from "react-toastify";
import                           "react-toastify/dist/ReactToastify.css";

import CrudComponent        from "./../zynappse-crud";
import VoucherPromoCategorySchema 
                            from "./VoucherPromoCategorySchema.js";
import FormContainer        from "./FormContainer";
import saveTrail            from '../../utils/saveTrail';

import {
    IS_VALID
}                           from "utils";

class EVoucherPromoCategory extends Component {
    constructor (props) {
        super(props);

        this.refreshTableReference;
        
        this.refreshTable = this.refreshTable.bind(this);
        this.renderModalButton = this.renderModalButton.bind(this);
        this.saveData = this.saveData.bind(this);
        this.deleteData = this.deleteData.bind(this);
    }

    refreshTable () {
        if (IS_VALID(this.refreshTableReference) && typeof this.refreshTableReference === 'function') {
            this.refreshTableReference();
        }
    }

    renderModalButton () {
        let {
            EVoucherPromoCategory,
            actions
        } = this.props;

        let {
            formType,
            isLoadingAction
        } = EVoucherPromoCategory;

        let buttons = [];

        let button = (name, callback) => (
            <Button
                bsStyle="primary"
                onClick={() => callback()}
                disabled={isLoadingAction}
            >
                {isLoadingAction ? <span><i className="fa fa-spinner fa-spin" style={{ color: "white" }}></i>&nbsp;</span> : ''}
                {name}
            </Button>
        );

        let buttonClose = (
            <Button
                disabled={isLoadingAction}
                onClick={() => {
                    if (!isLoadingAction) {
                        actions.setValue({
                            showModal: false
                        });
                    }
                }}
            >
                CLOSE
            </Button>
        );

        switch (formType.toUpperCase()) {
            case "CREATE":
                buttons.push(
                    button("CREATE", this.saveData),
                    buttonClose
                );
                break;
            case "UPDATE":
                buttons.push(
                    button("UPDATE", this.saveData),
                    buttonClose
                );
                break;
            case "DELETE":
                buttons.push(
                    button("DELETE", this.deleteData),
                    buttonClose
                );
                break;
            default:
                break;
        }
        return buttons;
    }

    saveData () {
        let {
            EVoucherPromoCategory,
            actions
        } = this.props;

        let {
            selectedData,
            formType,

            promoCategory
        } = EVoucherPromoCategory;

        if (
            !IS_VALID(promoCategory) ||
            !IS_VALID(promoCategory.trim())
        ) {
            toast.error("Promo Category is required.");
        } else {
            actions.setValue({
                isLoadingAction: true
            });

            let voucherPromoCategory = new Parse.Object("VoucherPromoCategory");

            if (
                formType === "UPDATE" &&
                IS_VALID(selectedData)
            ) {
                voucherPromoCategory = selectedData;
            }

            voucherPromoCategory.set("name", promoCategory.trim());

            voucherPromoCategory.save()
            .then((data) => {
                 actions.setValue({
                    isLoadingAction: false,
                    showModal: false
                });

                this.refreshTable();

                saveTrail(
                    formType.toUpperCase(),
                    {
                        id: data.id,
                        promoCategory: promoCategory.trim()
                    }    
                );
            })
            .catch((err) => {
                console.log("saveData error");
                console.log(err);

                actions.setValue({
                    isLoadingAction: false,
                    showModal: false
                });

                this.refreshTable();
            });
        }
    }

    deleteData () {
        let {
            EVoucherPromoCategory,
            actions
        } = this.props;

        let {
            selectedData
        } = EVoucherPromoCategory;

        actions.setValue({
            isLoadingAction: true
        });

        selectedData.set("isDeleted", true);

        selectedData.save()
        .then((data) => {
            actions.setValue({
                isLoadingAction: false,
                showModal: false
            });

            this.refreshTable();

            saveTrail(
                "DELETE",
                {
                    id: selectedData.id,
                    promoCategory: selectedData.get("name")
                }
            );
        })
        .catch((err) => {
            console.log("saveData error");
            console.log(err);

            actions.setValue({
                isLoadingAction: false,
                showModal: false
            });

            this.refreshTable();
        });
    }

    render () {
        let {
            EVoucherPromoCategory,
            accessjson,
            actions
          } = this.props;
      
          let {
            showModal,
            isLoadingAction,

            selectedData,
            formType,
            formTitle,

            promoCategory
          } = EVoucherPromoCategory;

        let crudProps = {
            schema: VoucherPromoCategorySchema,
            access: accessjson.access,
            moduleQuery: [
                { method: "ascending", column: "name" }
            ],
            refreshTable: (refreshTable) => {
                this.refreshTableReference = refreshTable;
            },
            customCreate: () => {
                actions.setValue({
                    showModal: true,
                    formType: "CREATE",
                    formTitle: "CREATE"
                });
            },
            customUpdate: (obj) => {
                let stateToUpdate = {
                    showModal: true,
                    formType: "UPDATE",
                    formTitle: "UPDATE",
                    formId: obj.id,
                    selectedData: obj
                };

                if (IS_VALID(obj.get("name"))) {
                    stateToUpdate.promoCategory = obj.get("name");
                }

                actions.setValue(stateToUpdate);
            },
            customDelete: (obj) => {
                let stateToUpdate = {
                    showModal: true,
                    formType: "DELETE",
                    formTitle: "DELETE",
                    formId: obj.id,
                    selectedData: obj
                };

                actions.setValue(stateToUpdate);
            }
        };

        let formContainerProps = {
            actions,

            formType,
            selectedData,

            promoCategory
        };

        return (
            <div>
                <Panel>
                    <Panel.Heading style={{
                        backgroundColor: '#D1282F',
                        color: 'white'
                    }}>
                        <h4>EVoucher Promo Category</h4>
                    </Panel.Heading>
                    <Panel.Body>
                        <CrudComponent {...crudProps}/>
                    </Panel.Body>
                </Panel>
                <Modal
                    bsSize={formType === "DELETE" ? null : "sm"}
                    show={showModal}
                    onHide={() => {
                        if (!isLoadingAction) {
                            actions.setValue({
                                showModal: false
                            });
                        }
                    }}
                >
                     <Modal.Header closeButton>
                        <Modal.Title>{formTitle.toUpperCase()}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <FormContainer {...formContainerProps}/>
                    </Modal.Body>
                    <Modal.Footer>
                        {this.renderModalButton()}
                    </Modal.Footer>
                </Modal>
                <ToastContainer />
            </div>
        );
    }
}

import {connect}            from 'react-redux';
import {bindActionCreators} from 'redux';
import {generics}           from 'actions';
import {
    SET_EVOUCHER_PROMO_CATEGORY
}                           from "actions/const";

function mapStateToProps(state) {
	var {
		accessjson,
        EVoucherPromoCategory
	} = state;
	return {
		accessjson,
        EVoucherPromoCategory
	};
}

function mapDispatchToProps(dispatch) {
  const actions = {
    setValue: (keyValueObj, actioType = SET_EVOUCHER_PROMO_CATEGORY) => generics.setValue(actioType, keyValueObj)
  };

  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EVoucherPromoCategory);


// WEBPACK FOOTER //
// ./components/EVoucherPromoCategory/index.js